import { gql } from '@apollo/client'

export const NOTE_SUBSCRIPTION = gql`
  subscription SubscribeToNote($person_id: Int) {
    noteChanged(person_id: $person_id) {
      id
      account_id
      created_at
      created_by {
        id
        email
        first_name
        last_name
      }
      content
      deleted
      updated_at
      updated_by_id
    }
  }
`
